import { Box, Card } from '@mui/material';
import ChangePasswordForm from '@/components/forms/profileSecurity/ChangePasswordForm';
import ChangeCodeForm from '@/components/forms/profileSecurity/ChangeCodeForm';
import TotpForm from '@/components/forms/profileSecurity/TotpForm';
import WebAuthnForm from '@/components/forms/profileSecurity/WebAuthnForm';
import useTitle from '@/hooks/useTitle';
import useAppStore from '@/store/app';
import { useEffect } from 'react';
import EncryptionForm from '@/components/forms/profileSecurity/EncryptionForm';

export default function Security() {
  useTitle('Security');
  const { setNavigation } = useAppStore();

  useEffect(() => {
    setNavigation(null);
  }, []);

  return (
    <Box
      sx={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: '10px',
        flex: 1,
      }}
    >
      <Card
        sx={{
          padding: '20px',
          width: {
            xs: '100%',
            sm: '90%',
            md: '500px',
          },
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <ChangePasswordForm />
      </Card>
      <Card
        sx={{
          padding: '20px',
          width: {
            xs: '100%',
            sm: '90%',
            md: '500px',
          },
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <ChangeCodeForm />
      </Card>
      <Card
        sx={{
          padding: '20px',
          width: {
            xs: '100%',
            sm: '90%',
            md: '500px',
          },
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <TotpForm />
      </Card>
      <Card
        sx={{
          padding: '20px',
          width: {
            xs: '100%',
            sm: '90%',
            md: '500px',
          },
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <WebAuthnForm />
      </Card>
      <Card
        sx={{
          padding: '20px',
          width: {
            xs: '100%',
            sm: '90%',
            md: '500px',
          },
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <EncryptionForm />
      </Card>
    </Box>
  );
}
